export default __webpack_public_path__ + "static/media/restartImg.fada73b4.svg";